/**
 * Organization and person names are written into invitation emails sent
 * from Lumoo's domain, so they cannot carry links or pass as Lumoo. Mirrors
 * public.display_name_issue, which enforces the same rule on client writes.
 */
const LINK_PATTERN = /:\/\/|www\.|[a-z0-9-]{2,}\.[a-z]{2,6}(?![a-z0-9])/i
const BRAND_PATTERN = /lumoo/i

export function displayNameIssue(
  name: string,
  { allowBrand = false }: { allowBrand?: boolean } = {}
): string | undefined {
  if (LINK_PATTERN.test(name)) {
    return 'Names cannot contain links or web addresses'
  }
  if (!allowBrand && BRAND_PATTERN.test(name)) {
    return 'Names cannot contain Lumoo'
  }
  return undefined
}

/** Zod refinement for a name field; pass `allowBrand` for Lumoo staff. */
export function refineDisplayName(options?: { allowBrand?: boolean }) {
  return (
    value: string,
    ctx: { addIssue: (issue: { code: 'custom'; message: string }) => void }
  ) => {
    const issue = displayNameIssue(value, options)
    if (issue) {
      ctx.addIssue({ code: 'custom', message: issue })
    }
  }
}
